import { fetchJson as client } from 'util/fetch';
import envDetect from '@tcc/env-detect';

const isProduction = envDetect.getCurrentEnv() === envDetect.environments.PRODUCTION;

const getOLHeaders = (extraHeaders) => {
  const headers = {
    ...extraHeaders,
    ...(localStorage.getItem('auth') && localStorage.getItem('auth') !== 'null'
      && { Authorization: localStorage.getItem('auth') }),
    'x-http-caller-id': process.env.npm_package_name,
    'x-http-caller-version': process.env.npm_package_version,
    'Content-Type': 'application/json',
    'x-data-legitimacy': 'LEGITIMATE'
  };

  return headers;
};

const networkAdapter = ({
  legacyOptions,
  options,
  useOL
}: {
  legacyOptions?: object | [object];
  options?: object | [object];
  useOL?: boolean;
}) => {
  let legacyOptionsValue, optionsValue;

  if (legacyOptions && !Array.isArray(legacyOptions)) {
    legacyOptionsValue = [legacyOptions];
  }
  if (options && !Array.isArray(options)) {
    optionsValue = [options];
  }
  let opts = legacyOptionsValue || optionsValue;
  if (useOL) {
    opts = optionsValue.map(option => {
      const olVersion = option.olVersion ? option.olVersion : '1';
      return ({
        url: isProduction
          ? `https://ol.na.climate.com/v${olVersion}/graphql`
          : `/v${olVersion}/graphql`, // to /v${olVersion}/graphql
        extraHeaders: getOLHeaders(option.headers),
        useClimateAuthHeaders:!isProduction, // Prevents a CORS error.
        userId: option.userId,
        method: 'POST',
        redirectsToLoginOnAuthFail: false,
        body: JSON.stringify({
          query: option.query,
          variables: option.variables
        })
      });
    });
  }
  if (opts.length === 1) {
    const [option] = opts;
    return client({
      ...option
    });
  } else {
    return Promise.all(opts.map(option => {
      return client({
        ...option
      });
    }));
  }
};

export default networkAdapter;
